<style>
.submit_form {
    margin: auto;
    display: flex;
    flex-direction: column;
    text-align: center;
    padding-bottom: 20px;
}
</style>
<script>

    import { mutations, goodsList } from '../mainStore.js';
    import SendForm from './SendForm.svelte';
    import CategoryItems from './CategoryItems.svelte';
    import config from '../config';
    import { onMount } from "svelte";
    onMount(() => {
        window.scrollTo(0,0)
    });
    let tabList = [
        {
            name: 'Внутренняя оснастка',
            items: $goodsList.filter(item => item.tabName == 'inner')
        },
        {
            name: 'Внешняя оснастка',
            items: $goodsList.filter(item => item.tabName == 'outer')
        },
        {
            name: 'Дополнительная оснастка',
            items: $goodsList.filter(item => item.tabName == 'additional')
        }
    ]
    let index = 0
</script>
<div class="submit_form">
    <SendForm />
</div>
